import { render, staticRenderFns } from "./update-config.vue?vue&type=template&id=72ce76d9&scoped=true&"
import script from "./update-config.vue?vue&type=script&lang=js&"
export * from "./update-config.vue?vue&type=script&lang=js&"
import style0 from "./update-config.vue?vue&type=style&index=0&id=72ce76d9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72ce76d9",
  null
  
)

export default component.exports